import { Scene } from 'phaser';

export class Boot extends Scene {
  constructor() {
    super('Boot');

    // Inject CSS.
    const style = document.createElement('style');
    style.textContent = `
      #game-container {
        width: 100dvw;   /* dynamic viewport units */
        height: 100dvh;
        overflow: hidden;
      }
    `;
    document.head.appendChild(style);
  }

  preload() {
    this.setupDefaultFilterMode();

    //  The Boot Scene is typically used to load in any assets you require for your Preloader, such as a game logo or background.
    //  The smaller the file size of the assets, the better, as the Boot Scene itself has no preloader.
    this.load.image(
      'new-spellcaster-logo_png_1',
      'game_assets/sprites/phaser_game/loading_screen/new-spellcaster-logo_png.png',
    );
    this.load.image(
      'loading-spinner',
      'game_assets/sprites/phaser_game/loading_screen/loading-spinner_png.png',
    );
    this.load.image(
      'loading-spinner_512x512',
      'game_assets/sprites/phaser_game/loading_screen/loading-spinner_512x512.png',
    );
    this.load.image(
      'forest-background',
      'game_assets/sprites/phaser_game/loading_screen/forest-background.png',
    );
    this.load.image(
      'npc_mentor_e_portrait',
      'game_assets/sprites/phaser_game/npcs/npc_mentor_e_portrait.png',
    );
    const preloaderMentorTexture = this.getRandomMentorTexture();
    // if we pick mentor_e that does mean we'll be loading it twice, but
    // we would have to load two images in any other case too so I figure that's ok
    this.load.image(
      'preloader-mentor-portrait',
      `game_assets/sprites/phaser_game/npcs/${preloaderMentorTexture}.png`,
    );
    this.load.image(
      '1x1sprite',
      'game_assets/sprites/phaser_game/placeholder/1x1sprite.png',
    );
    this.load.bitmapFont(
      'Aronui',
      'fonts/Aronui/Aronui_0.png',
      'fonts/Aronui/Aronui.fnt',
    );
    this.load.pack(
      'login-assets',
      'game_assets/sprites/phaser_game/login/login-assets.json',
    );
    this.load.pack(
      'phaser-game-audio-essential',
      'game_assets/audio/phaser_game_audio/phaser-game-audio-essential.json',
    );

    this.load.on('complete', () => {
      this.textures.get('Aronui').setFilter(Phaser.Textures.LINEAR);
      this.scene.start('MainScene');
    });
  }

  create() {
    window.addEventListener('orientationchange', () => {
      // Delay to let the browser finish its layout recalculation
      this.time.delayedCall(200, () => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        this.scale.resize(width, height);
        this.scale.refresh();
      });
    });
  }

  setupDefaultFilterMode() {
    const originalAddImage = this.textures.addImage;
    const originalAddSpriteSheet = this.textures.addSpriteSheet;

    // Override addImage to set filter mode on creation
    this.textures.addImage = function (key, source, dataSource) {
      const texture = originalAddImage.call(this, key, source, dataSource);
      if (texture && texture.source[0]) {
        if (texture.key !== 'Aronui') {
          texture.source[0].setFilter(Phaser.Textures.FilterMode.NEAREST);
        }
      }
      return texture;
    };

    this.textures.addSpriteSheet = function (key, source, dataSource) {
      const texture = originalAddSpriteSheet.call(
        this,
        key,
        source,
        dataSource,
      );
      if (texture && texture.source[0]) {
        if (texture.key !== 'Aronui') {
          texture.source[0].setFilter(Phaser.Textures.FilterMode.NEAREST);
        }
      }
      return texture;
    };
  }

  getRandomMentorTexture() {
    const guardians = [
      'npc_mentor_a_portrait',
      'npc_mentor_b_portrait',
      'npc_mentor_c_portrait',
      'npc_mentor_d_portrait',
      'npc_mentor_e_portrait',
    ];
    const randIdx = Math.floor(Math.random() * guardians.length);
    return guardians[randIdx];
  }
}
